import React, { useState } from 'react';
import PropTypes from 'prop-types';
import notify from 'Common/utils/notify';
import { toast } from 'react-toastify';
import axios from 'axios';
import Modal from 'Common/components/Modals/Modal';
import Button from 'Common/components/Button';
import ModalTitle from 'Common/components/Modals/ModalTitle';
import useQuestionFileFunctions from 'ProjectManager/DataManagement/Questionnaire/components/Question/Files/hooks/questionFileFunctions/useQuestionFileFunctions';

const FileDeleteModal = ({ question, fileId, onCancel, onSuccess }) => {
    const { deleteQuestionFile } = useQuestionFileFunctions(
        question.id,
        question.isCustom,
    );

    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        setIsDeleting(true);

        try {
            await deleteQuestionFile(fileId);
            await onSuccess();

            notify('Die Datei wurde erfolgreich gelöscht', {
                type: toast.TYPE.SUCCESS,
            });
        } catch (error) {
            if (!axios.isCancel(error)) {
                notify('Die Datei konnte nicht gelöscht werden', {
                    type: toast.TYPE.ERROR,
                });
            }
        }

        setIsDeleting(false);
    };

    return (
        <Modal
            isOpen
            onRequestClose={isDeleting ? undefined : onCancel}
            buttons={
                <>
                    <Button
                        text
                        dark
                        type="button"
                        onClick={onCancel}
                        disabled={isDeleting}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="button"
                        isLoading={isDeleting}
                        onClick={handleConfirm}
                        disabled={isDeleting}
                    >
                        Löschen
                    </Button>
                </>
            }
        >
            <ModalTitle>
                Du bist dabei die Datei zu löschen. Bist du dir sicher?
            </ModalTitle>
        </Modal>
    );
};

FileDeleteModal.propTypes = {
    question: PropTypes.object.isRequired,
    fileId: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default FileDeleteModal;
